var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sales-total-by-event", {
        attrs: {
          progress_bar_height: _vm.progress_bar_height,
          request_route_uri: _vm.request_route_uri,
          sale_route_name: _vm.sale_route_name,
          sale_route_uri: _vm.sale_route_uri,
          title: "Sales by event",
          filter_date: _vm.filter_date
        },
        on: { open_calendar: _vm.triggerCalendar }
      }),
      _vm._v(" "),
      _c("traffic-module"),
      _vm._v(" "),
      _vm.show_the_bottom === true
        ? _c(
            "div",
            [
              _vm.show_masonry === true
                ? [
                    _vm.loadingDataSet.loaded
                      ? _c("div", [_vm._m(0)])
                      : _c(
                          "div",
                          { ref: _vm.masonry_id, staticClass: "masonry" },
                          [
                            _c("div", {
                              staticClass:
                                "masonry-sizer col-xs-6 col-sm-4 col-md-3"
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.dashboards, function(dashboard) {
                              return _c(
                                "div",
                                {
                                  staticClass: "masonry-item",
                                  class: {
                                    "col-12 col-sm-12 col-md-6":
                                      dashboard.type ===
                                        _vm.moduleNames.sales ||
                                      dashboard.type === _vm.moduleNames.graph,
                                    "col-6 col-sm-6 col-md-3":
                                      dashboard.type === _vm.moduleNames.count
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "masonry-item--content dashboard-module "
                                    },
                                    [
                                      dashboard.type === _vm.moduleNames.graph
                                        ? _c("graph-list-module", {
                                            attrs: {
                                              sale_route_name:
                                                _vm.sale_route_name,
                                              laravel_route_uri:
                                                _vm.laravel_route_uri,
                                              request_route_uri:
                                                _vm.request_route_uri,
                                              parameters: dashboard,
                                              filter_date:
                                                dashboard.filter_date,
                                              load_items: _vm.load_items,
                                              read_request: "false"
                                            },
                                            on: {
                                              child_loaded: _vm.childrenLoaded,
                                              open_calendar:
                                                _vm.triggerCalendar,
                                              layout_changed: _vm.layoutChanged
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      dashboard.type === _vm.moduleNames.sales
                                        ? _c("sales-module-small", {
                                            attrs: {
                                              laravel_route_uri:
                                                _vm.laravel_route_uri,
                                              request_route_uri:
                                                _vm.request_route_uri,
                                              parameters: dashboard,
                                              filter_date:
                                                dashboard.filter_date,
                                              load_items: _vm.load_items,
                                              read_request: "false"
                                            },
                                            on: {
                                              child_loaded: _vm.childrenLoaded,
                                              open_calendar:
                                                _vm.triggerCalendar,
                                              layout_changed: _vm.layoutChanged
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      dashboard.type === _vm.moduleNames.count
                                        ? _c("single-count-module", {
                                            attrs: {
                                              laravel_route_uri:
                                                _vm.laravel_route_uri,
                                              request_route_uri:
                                                _vm.request_route_uri,
                                              load_items: _vm.load_items,
                                              filter_date: dashboard.filter_date
                                            },
                                            on: {
                                              open_calendar:
                                                _vm.triggerCalendar,
                                              layout_changed: _vm.layoutChanged
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("date-chooser", {
        attrs: {
          settings: _vm.dateChooser,
          trigger_open: _vm.dateChooser.display
        },
        on: { date_selected: _vm.dateSelected }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress" }, [
      _c("div", {
        staticClass: "progress-bar w-25",
        attrs: {
          role: "progressbar",
          "aria-valuenow": "25",
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }
      })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-482e587b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-482e587b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/dashboards/ClientDashboard.vue
// module id = 696
// module chunks = 0